import { http } from '../../../interfaces'

export interface OrganizationNameIdChildren {
  id: number
  organization_name: string
  children?: OrganizationNameIdChildren[]
}

export interface OrganizationHierarchy {
  upper_organizations: OrganizationNameIdChildren[]
  lower_organizations: OrganizationNameIdChildren[]
}

export async function getOrgHierarchy (orgId: number): Promise<OrganizationHierarchy> {
  return await http
    .get(`/api/v1/organizations/${orgId}/hierarchy/`, {
    }).then(value => value.data)
}
